export default Object.freeze({
  // SAMPLE_LABEL_SET_DELETE: 'SAMPLE_LABEL_SET_DELETE',
});
